// @ constants
const actionTypes = require('constants/actionTypes');

function reset() {
    return {
        type: actionTypes.HIRE_PAYMENT_METHOD_RESET
    };
}

function setTooltipShown(tooltipType) {
    return {
        type: actionTypes.HIRE_PAYMENT_METHOD_TOOLTIP_SHOWN,
        payload: {
            tooltipType
        }
    }
}

function setType(type) {
    return {
        type: actionTypes.HIRE_PAYMENT_METHOD_SET_TYPE,
        payload: {
            type
        }
    };
}

function setValue(value) {
    return {
        type: actionTypes.HIRE_PAYMENT_METHOD_SET_VALUE,
        payload: {
            value
        }
    };
}
function setInitialType(type) {
    return {
        type: actionTypes.HIRE_PAYMENT_METHOD_SET_INITIAL_TYPE,
        payload: {
            type
        }
    };
}

function setInitialValue(value) {
    return {
        type: actionTypes.HIRE_PAYMENT_METHOD_SET_INITIAL_VALUE,
        payload: {
            value
        }
    };
}
function validateStep() {
    return {
        type: actionTypes.HIRE_PAYMENT_METHOD_VALIDATE_STEP
    };
}

module.exports = {
    reset,
    setTooltipShown,
    setType,
    setValue,
    setInitialType,
    setInitialValue,
    validateStep
};
